import React, { ReactElement } from 'react';

import { useTheme } from '@24i/nxg-sdk-higgs';
import { View, Text } from '@24i/nxg-sdk-quarks';
import PackshotGrid from '@24i/nxg-sdk-gluons/src/components/containers/PackshotGrid';
import Loader from '@24i/nxg-sdk-gluons/src/components/ui/Loader';
import { getTelegramWebApp, isWebMobile } from '@24i/nxg-sdk-higgs/src/utils';

import { withWebHeader } from '../../../navigation/components/withWebHeader';
import getGenreScreenStyles from '../styles/index.web';
import { GenreWebProps } from '../types';

const GenreScreen = ({
    genreAssets = [],
    selectedGenre = '',
    styles: getStyles = getGenreScreenStyles,
    handlePackshotPress,
    isLoading,
    gridContainerRef,
}: GenreWebProps): ReactElement => {
    const { theme } = useTheme();
    const styles = getStyles(theme);

    return (
        <View style={styles.holder} ref={gridContainerRef}>
            {/* Only show the local title for desktop web - mobile will use the header title */}
            {!getTelegramWebApp() && (
                <View style={styles.pickerHolder}>
                    <Text style={styles.sectionTitle}>{selectedGenre}</Text>
                </View>
            )}
            <View style={styles.gridContainer}>
                <PackshotGrid items={genreAssets} onItemPress={handlePackshotPress} />
                {isLoading && <Loader />}
            </View>
        </View>
    );
};

GenreScreen.displayName = 'GenreScreen';

// IMPORTANT: We need different configurations:
// 1. For Telegram: Use 'sticky' variant to properly initialize back button without visual changes
// 2. For web mobile (non-Telegram): Use 'sticky' variant to ensure the header title is shown
// 3. For desktop web: Use normal header
export default (props: GenreWebProps) => {
    // Get environment information
    const isTelegram = !!getTelegramWebApp();
    const isMobile = isWebMobile();

    // Create a set of enhanced props to handle all cases
    const enhancedProps = {
        ...props,
        // Always use sticky for both Telegram and mobile web to ensure proper header display
        variant: isTelegram || isMobile ? 'sticky' : undefined,
        // This flags that we're on mobile web
        isMobileView: isMobile,
        // Explicitly set webHeaderTitle to ensure it's displayed in the header
        webHeaderTitle: props.selectedGenre,
        // Base layout settings
        fullWidth: true,
        hasMargin: false,
        noVerticalMargin: true,
        // Always force header visibility to ensure title is shown
        forceShowHeader: true,
    };

    return withWebHeader(GenreScreen)(enhancedProps);
};
